import { AdminListAgenciesCountFilter } from '../../graphql/API';
import { adminListAgenciesCount } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminListAgenciesCountApi = async (filter: AdminListAgenciesCountFilter): Promise<number> => {
    const result = await executeGql<string>(adminListAgenciesCount, { filter });
    return JSON.parse(processGqlResult<string>('adminListAgenciesCount', result));
};